module.exports = __webpack_public_path__ + "static/media/flames.2f9c9a63.svg";